<template>
    <div class="w-full p-8 bg-white border shadow-lg flex justify-start items-start">
        <div class="flex-shrinik-0 w-48 h-32 mr-8 bg-indigo-300 animate-pulse"></div>
        <div class="flex-grow flex flex-col">
            <h1 class="h-8 bg-gray-600 animate-pulse"></h1>
            <div class="flex items-center mt-2">
                <font-awesome-icon icon="fa-solid fa-calendar-days" class="text-primary mr-2" />
                <div class="h-3 bg-gray-300 flex-grow"></div>
            </div>
            <div class="flex items-center mt-2">
                <font-awesome-icon  :icon="['fas', 'location-dot']" class="text-primary mr-2" />
                <div class="h-3 bg-gray-300 flex-grow"></div>
            </div>
            <div class="mt-2">
                <p class="h-4 bg-gray-400 animate-pulse mt-2" v-for="(text, index) in 3" :key="index"></p>
            </div>
            <div class="flex justify-end mt-4">
                <div class="w-32 h-8 bg-indigo-400 animate-pulse"></div>
            </div>
        </div>
    </div>
</template>